'use client'

import { Asset } from '../../v2/components/Asset'
import ModalForm from '../../v2/components/ModalForm'
import { Button } from '../../v2/components/ui/button'
import Grid from '../grid'
import { RESOURCE_URL } from '@telesoft/lib/web/constants'
import { Post, Category, Asset as AssetType, Resource, Form } from '@telesoft/types/payload-types'
import { motion } from 'framer-motion'
import React, { ReactElement } from 'react'
import { BsChevronDown } from 'react-icons/bs'

interface Props {
  article: Post
  hasDownload: boolean
}
export default function ArticleHero({ article, hasDownload }: Props): ReactElement {
  const category: Category = article?.category as Category
  const image = article?.image as AssetType

  const resource = article.resource?.download as Resource | undefined
  const isResourceWalled = resource?.isWalled
  const downloadUrl = RESOURCE_URL + '/' + resource?.filename
  return (
    <Grid className="grid-rows-2 grid-rows-max lg:grid-rows-1 gap-0 lg:gap-8 min-h-[calc(100vh-80px)] bg-accent-1">
      <div className="col-span-full lg:col-span-6 xl:col-span-7 p-8 md:p-14 md:py-18 lg:p-20 lg:py-28  flex flex-col justify-center items-center relative">
        <div className="max-w-2xl">
          <h5 className="uppercase mb-1 text-sm opacity-50">{category?.title}</h5>
          <h1 className="lg:leading-normal text-2xl md:text-3xl font-extrabold lg:text-4xl xl:text-5xl mb-2 lg:mb-8">
            {article?.title}
          </h1>
          <p className="whitespace-pre-line">{article?.summary}</p>
          {hasDownload && (
            <div className="div mt-8">
              {isResourceWalled ? (
                <ModalForm
                  cmsForm={resource.form as Form}
                  buttonLabel="Download"
                  resourceID={resource?.id ?? null}
                />
              ) : (
                <Button asChild>
                  <a href={downloadUrl} target="_blank">
                    Download Now
                  </a>
                </Button>
              )}
            </div>
          )}
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="col-span-full lg:col-span-6 xl:col-span-5 overflow-hidden relative bg-black"
      >
        <Asset fill resource={image} imgClassName="object-cover object-center" />
        <div className="flex items-center w-full absolute bottom-0 right-0 z-10">
          <button
            type="button"
            onClick={() =>
              document.getElementById('article')!.scrollIntoView({ behavior: 'smooth' })
            }
            aria-label="prev-button"
            className="absolute bottom-0 right-0 bg-opacity-90 hover:bg-opacity-100 transition-all duration-300 text-xl lg:text-2xl h-16 w-16 lg:h-20 lg:w-20 bg-telesoft text-heading flex justify-center items-center"
          >
            <BsChevronDown className="animate-bounce mt-4" />
          </button>
        </div>
      </motion.div>
    </Grid>
  )
}
